import { useEffect } from 'react';
import { trackScreen } from '../client/OCAnalytics';

/**
 * Logs a screen_view for modals that aren't URL-driven (URL-driven screens are
 * covered by installScreenTracking). Call once at the top of the modal.
 */
export function useScreenView(screenName: string): void {
    useEffect(() => {
        trackScreen(screenName);
    }, [screenName]);
}
